export const getFarmlandUsageStatusMeta = (status?: string) => {
  switch (status) {
    case "created":
      return { color: "processing", label: "Үүсгэсэн" };
    case "pending":
      return { color: "default", label: "Хүлээгдэж буй" };
    case "rejected":
      return { color: "error", label: "Татгалзсан" };
    case "active":
      return { color: "success", label: "Зөвшөөрсөн" };
    case "deleted":
      return { color: "warning", label: "Устгасан" };
    case "cancelled":
      return { color: "magenta", label: "Цуцалсан" };
    case "expired":
      return { color: "purple", label: "Хугацаа дууссан" };
    default:
      return { color: "default", label: "Тодорхойгүй" };
  }
};
